import { Check } from "lucide-react";

export const STEPS = ["Attendee Type", "Your Details", "Attendance & Preferences", "Payment", "Confirmation"];

export default function StepIndicator({ current }) {
  return (
    <ol className="flex items-start justify-between" aria-label="Registration progress" data-testid="registration-step-indicator">
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={label} className="relative flex flex-1 flex-col items-center text-center" aria-current={active ? "step" : undefined}
            data-testid={`registration-step-${i + 1}-indicator`}>
            {i > 0 && <span className={`absolute right-1/2 top-5 h-px w-full -translate-y-1/2 ${done || active ? "bg-burgundy" : "bg-slate-300"}`} aria-hidden="true" />}
            <span className={`relative z-10 flex h-10 w-10 items-center justify-center rounded-full border-2 text-sm font-bold ${
              active ? "border-burgundy bg-burgundy text-white" : done ? "border-burgundy bg-white text-burgundy" : "border-slate-300 bg-white text-slate-600"}`}>
              {done ? <Check size={18} aria-hidden="true" /> : i + 1}
            </span>
            <span className={`mt-2 hidden text-xs sm:block ${active ? "font-semibold text-navy" : "text-slate-600"}`}>{label}</span>
            <span className="sr-only">{done ? "(completed)" : active ? "(current step)" : ""}</span>
          </li>
        );
      })}
    </ol>
  );
}
